/**
 *  Boost
 *
 *  Created by Legman on 07/06/2017.
 *
 */

/**
 * @class
 * @extends PIXI.Container
 */
export default class Boost extends PIXI.Container  {
    /**
     * @param owner
     */
    constructor(owner) {
        super();

        /**
         * @member {number}
         */
        this.duration = 1;

        /**
         * @member {number}
         */
        this.multiplier = 1.6;

        /**
         * @param {RaceCar}
         */
        this._owner = owner;

        /**
         * @type {number}
         * @private
         */
        this._timeout = 0;

        /**
         * @type {boolean}
         * @private
         */
        this._active = false;
    }

    init() {
        this._startBoost();
    }

    /**
     * @param options
     */
    destroy(options) {
        super.destroy(options);
    }

    /**
     * @param {number} dt
     */
    update(dt) {
        if (this._active) {
            if (this._timeout <= 0) {
                this._stopBoost();
            } else this._timeout -= dt;
        }
    }

    /**
     * @protected
     */
    _startBoost() {
        this._owner.startBoost(this.multiplier);
        this._timeout = this.duration;
        this._active = true;
    }

    /**
     * @protected
     */
    _stopBoost() {
        this._owner.stopBoost();
        this._owner.usingPowerup = false;
        this._active = false;
    }

    /**
     * @returns {RaceEntity}
     */
    get owner() {
        return this._owner;
    }

    /**
     * @returns {boolean}
     */
    get active() {
        return this._active;
    }
}